import Marquee from './Marquee/Marquee';
import TrackDetails from './TrackDetails/TrackDetails';
import Volume from './Volume/Volume';
import PlayerWaveform from './Waveform/PlayerWaveform';
import TrackRowWaveform from './Waveform/TrackRowWaveform';
export { PlayerWaveform, TrackDetails, TrackRowWaveform, Volume, Marquee };